import { render, staticRenderFns } from "./feedbackStat.vue?vue&type=template&id=23308760&scoped=true"
import script from "./feedbackStat.vue?vue&type=script&lang=js"
export * from "./feedbackStat.vue?vue&type=script&lang=js"
import style0 from "./feedbackStat.vue?vue&type=style&index=0&id=23308760&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23308760",
  null
  
)

export default component.exports